export type Lead = {
  id:                   string;
  tenant_id:            string;
  name:                 string;
  email:                string | null;
  phone:                string | null;
  event_type:           string | null;
  event_date:           string | null;
  message:              string | null;
  status:               string;
  source:               string | null;
  internal_notes:       string | null;
  updated_at:           string | null;
  created_at:           string;
  converted_client_id:  string | null;
};

export type LeadNote = {
  id:         string;
  tenant_id:  string;
  lead_id:    string;
  user_id:    string | null;
  note:       string;
  created_at: string;
};

export type ActivityLog = {
  id:          string;
  tenant_id:   string;
  user_id:     string | null;
  action:      string;
  entity:      string;
  entity_id:   string | null;
  entity_name: string | null;
  created_at:  string;
};

export type Appointment = {
  id:               string;
  tenant_id:        string;
  lead_id:          string | null;
  title:            string;
  appointment_type: string;
  status:           string;
  start_at:         string;
  end_at:           string | null;
  location:         string | null;
  notes:            string | null;
};

export const STATUS_CFG: Record<string, { label: string; dot: string; badge: string }> = {
  new:       { label: "New",       dot: "bg-sky-400",     badge: "bg-sky-50 text-sky-600 border-sky-200" },
  contacted: { label: "Contacted", dot: "bg-amber-400",   badge: "bg-amber-50 text-amber-600 border-amber-200" },
  booked:    { label: "Booked",    dot: "bg-emerald-400", badge: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  lost:      { label: "Lost",      dot: "bg-red-400",     badge: "bg-red-50 text-red-600 border-red-200" },
};

export const SOURCE_CFG: Record<string, { label: string; icon: string; cls: string }> = {
  public_website: { label: "Website",      icon: "ri-global-line",     cls: "bg-emerald-50 text-emerald-600 border-emerald-200" },
  ai_assistant:   { label: "AI Assistant", icon: "ri-robot-line",      cls: "bg-violet-50 text-violet-600 border-violet-200" },
  contact_form:   { label: "Contact Form", icon: "ri-mail-line",       cls: "bg-sky-50 text-sky-600 border-sky-200" },
  invitation:     { label: "Invitation",   icon: "ri-gift-line",       cls: "bg-rose-50 text-rose-600 border-rose-200" },
  manual:         { label: "Manual",       icon: "ri-add-circle-line", cls: "bg-slate-100 text-slate-500 border-slate-200" },
  other:          { label: "Other",        icon: "ri-question-line",   cls: "bg-orange-50 text-orange-600 border-orange-200" },
};

export const fmtDate = (d: string | null | undefined) => {
  if (!d) return "—";
  return new Date(d).toLocaleDateString("en-US", { month: "short", day: "numeric", year: "numeric" });
};

export const fmtDateTime = (d: string) =>
  new Date(d).toLocaleString("en-US", {
    month: "short", day: "numeric", year: "numeric",
    hour: "2-digit", minute: "2-digit",
  });

export const DEFAULT_JOB_STEPS = [
  { step_key: "contract_deposit", title: "Contract / Deposit", sort_order: 0 },
  { step_key: "shoot_scheduled",  title: "Shoot Scheduled",    sort_order: 1 },
  { step_key: "shoot_completed",  title: "Shoot Completed",    sort_order: 2 },
  { step_key: "editing",          title: "Editing",            sort_order: 3 },
  { step_key: "client_selection", title: "Client Selection",   sort_order: 4 },
  { step_key: "final_delivery",   title: "Final Delivery",     sort_order: 5 },
  { step_key: "completed",        title: "Completed",          sort_order: 6 },
];